import { render, staticRenderFns } from "./TradeCertificates.vue?vue&type=template&id=4ae7488a&scoped=true"
import script from "./TradeCertificates.vue?vue&type=script&lang=js"
export * from "./TradeCertificates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae7488a",
  null
  
)

export default component.exports